const minimumLongitude = -180.0;
const maximumLongitude = 180.0;
const minimumLatitude = -90.0;
const maximumLatitude = 90.0;

const ONE_KM = 0.01;

export function isValidLocation(latitude, longitude) {
    if (Math.abs(latitude) < ONE_KM && Math.abs(longitude) < ONE_KM)
        return false;
    //if ((latitude === 0) && (longitude === 0)) return false;
    if (!isValidLatitude(latitude)) return false;
    if (!isValidLongitude(longitude)) return false;
    return true;
}

function isValidLatitude(latitude) {
    return latitude >= minimumLatitude && latitude <= maximumLatitude;
}

function isValidLongitude(longitude) {
    return longitude >= minimumLongitude && longitude <= maximumLongitude;
}